/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_Contract_TypeInputs */

const cs_contracts_contract_type = /** @type {(inputs: Contracts_Contract_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ smlouvy`)
};

const en_contracts_contract_type = /** @type {(inputs: Contracts_Contract_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract type`)
};

/**
* | output |
* | --- |
* | "Contract type" |
*
* @param {Contracts_Contract_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_contract_type = /** @type {((inputs?: Contracts_Contract_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_Contract_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_contract_type(inputs)
	return cs_contracts_contract_type(inputs)
});